<template>
  <div class="typeArea">
    <div class="top">
      <div class="top-left">
        <div class="slogn">
          <div>健安德致力于</div>
          <div>更健康的世界</div>
        </div>
        <div class="item">
          <img class="line1" src="@/assets/images/image110.png" alt="">
          <div class="line2">
            <div class="line2-left"><constantNum :setNumber="6000" :duration="numSpeed"></constantNum></div>
            <div class="line2-right">
              <div>+</div>
              <div>项</div>
            </div>
          </div>
          <div class="line3">客户认同·至今健安德累计完成6000余项试验</div>
        </div>
        <!-- <defaultImg :src="require('@/assets/images/image32.png')"></defaultImg> -->
      </div>
      <div class="top-right">
        <div class="top-right-item">
          <div class="top-right-item-title">
            <img src="@/assets/images/image140.png" alt="">
            <span>能力资质</span>
          </div>
          <div class="top-right-item-content">
            贵州健安德科技有限公司是国内较早具备生态环境部“化学品测试机构”、农业农村部“农药登记试验机构”、中国合格评定国家认可委员会“CNAS GLP”、国家药品监督管理局“化妆品注册和备案检验检测机构”资质的专业检测机构。公司同时具备危险化学品、消毒产品等化学品检测资质，共覆盖产品化学、环境影响、健康毒理等2000余项资质参数，是西南地区门类齐全、素质过硬、服务全面的第三方检测机构。
          </div>
        </div>
        <div class="top-right-item mg-top20">
          <div class="top-right-item-title">
            <img src="@/assets/images/image141.png" alt="">
            <span>设施设备</span>
          </div>
          <div class="top-right-item-content">
            实验设施面积7000㎡，拥有总价值超过5000万元的实验设备近1000台套。已经建成SPF级实验动物房、普通级实验动物房、农药全组分分析平台、水生和陆生生态环境评价系统等实验装置。成立以来，已累计为包括世界五百强在内的500多家化学品企业提供服务。
          </div>
        </div>
        <div class="top-right-item mg-top20">
          <div class="top-right-item-title">
            <img src="@/assets/images/image142.png" alt="">
            <span>人才团队</span>
          </div>
          <div class="top-right-item-content">
            健安德目前拥有各类技术人员百余名，其中硕士、博士占比超过30%，核心团队具有近20年的从业经历。拥有来自环境化学、信息学、遗传学、分析化学、质量保证方面的专业高层次人才，拥有“国务院专家津贴”、“西部之光学者”等学术称号。20多名来自中科院、协和、川大等一流高校的硕士组成技术骨干，为客户提供专业的、全方位的服务。
          </div>
        </div>
        
      </div>
    </div>
    <div class="bottom">
      <div class="box">
        <defaultImg :src="require('@/assets/images/image143.png')"></defaultImg>
        <div>
          <div class="line1">
            <div class="line1-left"><constantNum :setNumber="30" :duration="numSpeed"></constantNum>%</div>
            <div class="line1-right">
              <div>+</div>
              <div></div>
            </div>
          </div>
          <div class="line2"></div>
          <div class="line3">硕博人员占比</div>
        </div>
        <defaultImg :src="require('@/assets/images/image144.png')"></defaultImg>
        <div>
          <div class="line1">
            <div class="line1-left"><constantNum :setNumber="7000" :duration="numSpeed"></constantNum></div>
            <div class="line1-right">
              <div></div>
              <div>m²</div>
            </div>
          </div>
          <div class="line2"></div>
          <div class="line3">实验室面积</div>
        </div>
        <div>
          <div class="line1">
            <div class="line1-left"><constantNum :setNumber="1000" :duration="numSpeed"></constantNum></div>
            <div class="line1-right">
              <div>+</div>
              <div>台套</div>
            </div>
          </div>
          <div class="line2"></div>
          <div class="line3">各类实验设备</div>
        </div>
        <defaultImg :src="require('@/assets/images/image145.png')"></defaultImg>
        <div>
          <div class="line1">
            <div class="line1-left"><constantNum :setNumber="500" :duration="numSpeed"></constantNum></div>
            <div class="line1-right">
              <div>+</div>
              <div>家</div>
            </div>
          </div>
          <div class="line2"></div>
          <div class="line3">服务的企业</div>
        </div>
        <defaultImg :src="require('@/assets/images/image114.png')"></defaultImg>
      </div>
      <!-- <defaultImg :src="require('@/assets/images/image33.png')"></defaultImg> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'enterpriseIntroduction',
  data () {
    return {
      numSpeed: 1500,
      introduction: `<p>贵州健安德科技有限公司是国内较早具备生态环境部&ldquo;化学品测试机构&rdquo;、农业农村部&ldquo;农药登记试验机构&rdquo;、中国合格评定国家认可委员会&ldquo;CNAS GLP&rdquo;资质的专业检测机构。公司同时具备危险化学品、化妆品、消毒产品等化学品检测资质，是西南地区门类齐全、素质过硬、服务全面的第三方检测机构。</p>
                    <p>&nbsp;</p>
                    <p>健安德目前拥有各类技术人员百余名，其中硕士、博士占比超过25%，核心团队具有近20年的从业经历。拥有来自环境化学、信息学、遗传学、分析化学、质量保证方面的专业高层次人才，拥有&ldquo;国务院专家津贴&rdquo;、&ldquo;西部之光学者&rdquo;等学术称号。20多名来自中科院、协和、川大等一流高校的硕士组成技术骨干，为客户提供专业的、全方位的服务。</p>
                    <p>&nbsp;</p>
                    <p>实验设施面积7000 m&sup2;，拥有总价值超过5000万元的实验设备近1000台套。已经建成SPF级实验动物房、普通级实验动物房、农药全组分分析平台、水生和陆生生态环境评价系统等实验装置。成立以来，已累计为包括世界五百强在内的500多家化学品企业提供服务。 公司立足GLP，深耕行业蕴含的价值。利用轻代码、低代码平台，公司自主研发了CarsonTM低代码实验室信息管理平台，可为研发、检测（符合CMA、GLP、CNAS等体系）和工业实验室提供数据在线采集和溯源服务。公司建立了和农药、化学品等行业密切相关的化学成分信息库、杂质的分离、提取和检测数据库、中国环境表征毒理数据库、病理数据库等专业知识库，筛选汇集了高质量数据，开发了产品安全性预测、风险评估和辅助设计模型，助力化学品产品研发、登记和迭代。</p>
                    <p>&nbsp;</p>
                    <p>公司已经完成种子轮、天使轮融资，正在进行A轮融资，正在努力向三到五年上市目标而努力。</p>
                    `
    }
  },
  methods: {},
}
</script> 

<style lang='less' scoped>
  .top{
    overflow: hidden;
    .top-left{
      float: left;
      .slogn{
        font-weight: bold;
        font-size: 48px;
        letter-spacing: 2px;
        &>div:last-child{
          margin-top: 3px;
        }
      }
      // img{
      //   margin-top: 75px;
      // }
      .item{
        margin-top: 75px;
        .line1{
          display: block;
        }
        .line2{
          display: flex;
          .line2-left{
            color: #DB0000;
            font-size: 96px;
            font-weight: bold;
          }
          .line2-right{
            color: #DB0000;
            font-size: 20px;
            font-weight: bold;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 10px 0;
            .textR{
              text-align: right;
            }
          }
        }
        .line3{
          color: #3D3D3D;
          font-size: 18px;
        }
      }
    }
    .top-right{
      float: right;
      width: 750px;
      padding-top: 10px;
      font-size: 14px;
      color: #333333;
      .top-right-item{
        .top-right-item-title{
          color: #DB0000;
          font-weight: bold;
          display: flex;
          align-items: center;
          font-size: 16px;
          img{
            margin-right: 10px;
          }
        }
        .top-right-item-content{
          line-height: 20px;
          margin-top: 5px;
          padding-left: 30px;
        }
      }
    }
  }
  .bottom{
    // img{
    //   margin: 80px 0;
    // }
    .box{
      margin: 80px 0;
      display: flex;
      flex-wrap: wrap;
      &>div,img{
        height: 380px;
        width: 360px;
        // background-color: rgb(70, 57, 57);
      }
      &>div:nth-child(2),&>div:nth-child(4){
        background-color: #DB0000;
      }
      &>div:nth-child(5),&>div:nth-child(7){
        background-color: #333333;
      }
      &>div{
        // padding: 87px 105px 0px;
        box-sizing: border-box;
        padding-top: 95px;
        .line1{
          display: flex;
          justify-content: center;
          .line1-left{
            color: white;
            font-size: 70px;
            font-weight: bold;
          }
          .line1-right{
            color: white;
            font-size: 20px;
            font-weight: bold;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 10px 0;
            .textR{
              text-align: right;
            }
          }
        }
        .line2{
          border-top: 1px solid white;
          width: 108px;
          margin: 26px auto 30px;
        }
        .line3{
          color: white;
          text-align: center;
          font-size: 18px;
        }
      }
    }
  }
</style>
